import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { ReactElement, ReactNode } from "react";

const sizes = {
  "2xl": "sm:max-w-2xl",
  "3xl": "sm:max-w-3xl",
  "4xl": "sm:max-w-4xl",
  "5xl": "sm:max-w-5xl",
  lg: "sm:max-w-lg",
  md: "sm:max-w-md",
  sm: "sm:max-w-sm",
  xl: "sm:max-w-xl",
  xs: "sm:max-w-xs",
};

export const Dialog = ({
  backdropClassName,
  children,
  className,
  containerClassName,
  size = "lg",
  ...props
}: {
  backdropClassName?: string;
  children: ReactNode;
  className?: string;
  containerClassName?: string;
  size?: keyof typeof sizes;
} & Omit<Headless.DialogProps, "as" | "className">): ReactElement => (
  <Headless.Dialog {...props}>
    <Headless.DialogBackdrop
      className={clsx(
        "fixed inset-0 flex w-screen justify-center overflow-y-auto bg-zinc-950/25 px-2 py-2 transition duration-100 data-[closed]:opacity-0 data-[enter]:ease-out data-[leave]:ease-in focus:outline-0 sm:px-6 sm:py-8 lg:px-8 lg:py-16 dark:bg-zinc-950/50",
        backdropClassName,
      )}
      transition
    />

    <div
      className={clsx(
        "fixed inset-0 w-screen overflow-y-auto pt-6 sm:pt-0",
        containerClassName,
      )}
    >
      <div className="grid min-h-full grid-rows-[1fr_auto] justify-items-center sm:grid-rows-[1fr_auto_3fr] sm:p-4">
        <Headless.DialogPanel
          className={clsx(
            className,
            sizes[size],
            "row-start-2 w-full min-w-0 rounded-t-3xl bg-white p-[--gutter] shadow-lg ring-1 ring-zinc-950/10 [--gutter:theme(spacing.8)] sm:mb-auto sm:rounded-2xl dark:bg-zinc-900 dark:ring-white/10 forced-colors:outline",
            "transition duration-100 will-change-transform data-[closed]:translate-y-12 data-[closed]:opacity-0 data-[enter]:ease-out data-[leave]:ease-in sm:data-[closed]:translate-y-0 sm:data-[closed]:data-[enter]:scale-95",
          )}
          transition
        >
          {children}
        </Headless.DialogPanel>
      </div>
    </div>
  </Headless.Dialog>
);
